import React from 'react';
import PropTypes from 'prop-types';
import {observer, PropTypes as mobxPropTypes } from 'mobx-react';
import {observable, computed, makeObservable} from 'mobx';

import { formUtilsService } from '../../core/services/form-utils.service';
import FormLabel from './form-label';
import Checkbox from './checkbox';

@observer
export default class CheckboxGroup extends React.Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.array,
      mobxPropTypes.observableArray ]),
    onChange: PropTypes.func.isRequired,

    required: PropTypes.bool,
    forceToType: PropTypes.string,
    charLimit: PropTypes.number,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    labelText: PropTypes.string,
    labelTextIsSrOnly: PropTypes.bool,
    labelErrorIsSrOnly: PropTypes.bool,
    getIsValid: PropTypes.func,
    errorMessage: PropTypes.string,
    optionsList: PropTypes.array,
    announceError: PropTypes.bool,
    renderExtraElements: PropTypes.func,
    showSelectAll: PropTypes.bool
  }

  static defaultProps = {
    value: [],
    className: '',
    labelText: '',
    labelTextIsSrOnly: false,
    labelErrorIsSrOnly: false,
    required: false,
    disabled: false,
    errorMessage: 'Please select at least one option.',
    optionsList: [],
    forceToType: 'STRING'
  }

  @observable hasVisibleError = false;

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  validate = () => {
    //delay until end of store update
    setTimeout(() => {
      this.hasVisibleError = formUtilsService.checkboxGroupIsInvalid(this.props.required, this.props.value);
    }, 0);
  }

  @computed get allCheckboxesChecked() {
    return this.props.value.length === this.props.optionsList.length;
  }

  //this handler should be passed to all checkboxes in the list
  handleCheckboxOnChange = (input) => {
    const changedValue = formUtilsService.cast(input.value, this.props.forceToType);
    const valueArray = this.props.value;
    const index = valueArray.indexOf(changedValue);

    if (index > -1) {
      valueArray.splice(index, 1);
    } else {
      valueArray.push(changedValue);
    }

    this.props.onChange(this.props.id, valueArray, changedValue);
    this.validate();
  }

  onBlur = () => {
    this.validate();
  }

  selectAll = (e, shouldCheckAllBoxes) => {
    e.preventDefault();
    if (shouldCheckAllBoxes) {
      const allValues = this.props.optionsList.map(option => option.value);
      this.props.onChange(this.props.id, allValues)
    } else {
      this.props.onChange(this.props.id, [])
    }
    this.validate();
  }

  render() {
    return (
      <div className={`form-group ${this.hasVisibleError ? 'has-error' : ''}`}>
        <fieldset id={this.props.id} className={this.props.className} onBlur={this.onBlur}>
          <FormLabel
            hasError={this.hasVisibleError}
            fieldIsRequired={this.props.required}
            labelText={this.props.labelText}
            labelTextIsSrOnly={this.props.labelTextIsSrOnly}
            labelErrorIsSrOnly={this.props.labelErrorIsSrOnly}
            errorMessage={this.props.errorMessage}
            announceError={this.props.announceError} />
          {this.props.showSelectAll &&
            <div className="checkbox-group__select-all">
              <button role="button" className="as-link " onClick={(e) => this.selectAll(e, true)}>Select All</button>
              <button role="button" className={`as-link ${this.props.value.length === 0 ? 'disabled' : ''}`} onClick={(e) => this.selectAll(e, false)}>Deselect All</button>
            </div>
          }
          <div className="checkbox-group__list">
            {this.props.optionsList.map(option => {
              return (
                <React.Fragment key={option.value}>
                  <Checkbox
                    value={option.value}
                    key={option.value}
                    title={option.title}
                    checked={this.props.value.indexOf(option.value) > -1}
                    onChange={this.handleCheckboxOnChange} />
                  {Boolean(this.props.renderExtraElements) && this.props.renderExtraElements(option)}
                </React.Fragment>
              )
            })}
          </div>
        </fieldset>
      </div>
    )
  }
}
